import createClient from 'openapi-fetch'

import type { paths } from './schema'

/**
 * O browser fala apenas com a Codout.Support.Api, sempre same-origin (proxy do Vite em dev,
 * mesmo host atras de reverse proxy em producao). O cookie de sessao HttpOnly e enviado
 * automaticamente pelo browser; o client nunca le nem grava token algum.
 *
 * baseUrl usa `window.location.origin` (nao string vazia): um path puramente relativo falha
 * ao construir um `Request` fora de um documento de browser real (Node/undici, inclusive sob
 * jsdom em teste, exige uma URL absoluta). Resolver contra a origem atual mantem a chamada
 * same-origin em qualquer ambiente sem depender de resolucao implicita de URL relativa.
 */
export const apiClient = createClient<paths>({
  baseUrl: window.location.origin,
  credentials: 'same-origin',
})
